<mat-toolbar class="toolbar-subtitle">
  <mat-toolbar-row>Contact information</mat-toolbar-row>
</mat-toolbar>
<div class="flex-display">
  <mat-form-field class="form-column flex-30">
    <mat-label>Homepage URL</mat-label>
    <input
      matInput
      placeholder="Homepage URL"
      [(ngModel)]="website"
      #websiteInput="ngModel"
      [disabled]="!editMode"
      name="website"
      id="website"
      gymfinderUrlValidator />
    @if (websiteInput.errors?.['invalidUrl']) {
      <mat-error>
        Invalid Homepage URL
      </mat-error>
    }
  </mat-form-field>
  <mat-form-field class="form-column flex-20">
    <mat-label>Email</mat-label>
    <input
      matInput
      placeholder="Email"
      [(ngModel)]="email"
      name="email"
      id="email"
      [disabled]="!editMode" />
  </mat-form-field>

  <mat-form-field class="form-column flex-10">
    <mat-label>Phone number</mat-label>
    <input
      matInput
      placeholder="Phone number"
      [(ngModel)]="phone"
      name="phone"
      id="phone"
      [disabled]="!editMode" />
  </mat-form-field>
  <mat-form-field class="form-column flex-10">
    <mat-label>Instagram</mat-label>
    <span matPrefix>&#64;&nbsp;</span>
    <input
      matInput
      placeholder="Instagram"
      [(ngModel)]="instagram"
      #instagramInput="ngModel"
      name="instagram"
      id="instagram"
      [disabled]="!editMode"
      [pattern]="instagramRegex" />
    @if (instagramInput.errors?.['pattern']) {
      <mat-error>
        Invalid Instagram username
      </mat-error>
    }
  </mat-form-field>
</div>
